import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetDriversList } from '../../store/FLEET/Equipments/equipmentsSlice';
import { useTranslation } from 'react-i18next';

const useGetDriversList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();
  const { DriversList, loadingDrivers: loading, errorDrivers: error } = useAppSelector(state => state.Equipments);

  useEffect(() => {
    // if (DriversList?.length === 0) {
      dispatch(GetDriversList());
    // }
  }, []);

  var OptionsDrivers = DriversList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2,
    personId: item.personId,
    personNo: item.personNo,
    hasVehicle: item.hasVehicle,
    mobile: item.mobile,
    isDisabled: item.hasVehicle
  }));

  return { DriversList, OptionsDrivers, loading, error };
};

export default useGetDriversList;
